import config from '../../config/environment.ts';
import { MEDIA_IMAGE_TYPE, MediaImagePath } from './media-image-path.ts';

export function getKeyFromUrl(url: string): string {
  const mediaDomains = config['ll-media'].mediaDomains;
  const uri = new URL(url);
  const host = uri.hostname;
  if (!mediaDomains.includes(host)) {
    throw new Error('Invalid url');
  }

  // Remove the leading slash
  const key = uri.pathname.substring(1);
  console.log('Valid host name, key is', key);
  return key;
}

export function isMediaImage(url: string): boolean {
  try {
    const key = getKeyFromUrl(url);
    const mediaImagePath = MediaImagePath.fromKey(key);
    return mediaImagePath.type === MEDIA_IMAGE_TYPE;
  } catch {
    return false;
  }
}
